import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout title="页面未找到 - 明星动态平台">
      <div className="px-4 md:px-8 py-20 md:py-28">
        <div className="relative flex flex-col items-center justify-center text-center">
          <span className="font-heading text-[7rem] md:text-[11rem] leading-none text-background-200 select-none">
            404
          </span>
          <div className="relative -mt-10 md:-mt-16">
            <h1 className="font-heading text-2xl md:text-3xl text-foreground-950">
              这个页面走丢了
            </h1>
            <p className="text-sm md:text-base text-foreground-500 mt-3 font-body max-w-md">
              你访问的页面不存在或已被移动，不妨回到首页，继续了解白石茉莉奈的最新动态与作品。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
              <Link
                to="/"
                className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-body hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                返回首页
              </Link>
              <Link
                to="/news"
                className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-body hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                浏览最新资讯
              </Link>
            </div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}